import { PERMS, RecuranceModes } from "const";
import { TaskStatus } from "redux/workplace/wpTypes";

export interface Position {
	left: number;
	top: number;
}

export interface tb_PermConfig {
	uid: string | null;
	entryId: number | null;
	permName: PERMS | null;
	allow: boolean | null;
	userId: number | null;
	division: string | null;
	department: string | null;
	position: string | null;
}

export type DropdownOption = {
	label: string;
	value: string;
};

export interface sp_GetWebUserId {
	webUserId: number;
	customerIsCdSys: number;
}

export interface EmployeeOrg {
	companyName: string;
	divisionName: string;
	departmentName: string;
	positionName: string;
	displayName2: string;
	headId1: number | null;
	userID: number | null;
	tagId: number | null;
}

export interface SavePostInfoParm {
	deviceId: string;
	postIdTop: string | null;
	title: string | null;
	projectId: number | null;
	assignerId: number | null;
	respondId: number | null;
	planStartDate: Date | null;
	planFinishedDate: Date | null;
	requestBy: number | null;
	taskStatus: TaskStatus | null;
	tagRemove: number[] | null;
	isConvert2TaskMode?: boolean | null;
	isCreateSubTask?: boolean | null;
}


export interface TaskRecuranceData {
	taskId: string | null;
	taskName: string | null;
	projectId: number | null;
	tagIds: string | null;
	assignerId: number | null;
	respondId: number | null;
	requesterId: number | null;
	finishedByNum: number | null;
	finishedByUnit: string | null;
	createDate?: Date | null;
	updateDate?: Date | null;
	createBy?: number | null;
	updateBy?: number | null;
	recuances: TaskRecuranceDtlData[] | null;
}


export interface TaskRecuranceDtlData {
	entryId?: number | null;
	postId?: string | null;
	seq?: number | null;

	recuranceMode: RecuranceModes;
	startDate?: Date | null;
	expireDate?: Date | null;

	// ครั้งเดียว 
	specificDate?: Date | null;  // วันที่

	// รายวัน
	dailyOnTime?: string | null; // รายวัน: เวลา
	dailyExceptDay?: number[] | null; // ยกเว้นวันที่
	dailyExceptWeekDay?: number[] | null; // วันเว้นวัน

	// รายอาทิตย์
	weeklyEveryWeekDay?: number[] | null;
	weeklyExceptDay?: number[] | null; // ยกเว้นวันที่

	// รายเดือน
	monthlyEveryDay?: number[] | null;
	monthlyExceptWeekDay?: number[] | null; // วันเว้นวัน
	monthlyExceptMonth?: number[] | null;

	// รายปี
	yearlyEveryDay?: number[] | null;
	yearlyEveryMonth?: number[] | null;

	recuranceText?: string | null;
	lastTaskCreate?: Date | null;
	lastTaskId?: string | null;

}

export interface TaskRecurance2Data {
	taskId?: string | null;
	recuranceMode: RecuranceModes;
	freqDay: number | null;
	freqWeek: number | null;
	freqMonth: number | null;
	freqYear: number | null;
	startDate?: Date | null;
	expireDate?: Date | null;
	specificDate?: Date | null;
	dailyOnTime?: string | null;
	dailyExceptDay?: string | null;
	dailyExceptWeekDay?: string | null;
	weeklyEveryWeekDay?: string | null;
	weeklyExceptDay?: string | null;
	monthlyEveryDay?: string | null;
	monthlyExceptWeekDay?: string | null;
	monthlyExceptMonth?: string | null;
	yearlyEveryDay?: string | null;
	yearlyEveryMonth?: string | null;
	recuranceText?: string | null;
	createTaskBefore?: number | null;
	createTaskBeforeUnit: "D" | "W" | "M" | null;
	lastTaskCreate?: Date | null;
	lastTaskId?: string | null;
	nextFinishedDate1?: Date | null;
	nextFinishedDate2?: Date | null;
	nextFinishedDate3?: Date | null;
	nextFinishedDate4?: Date | null;
	nextFinishedDate5?: Date | null;


	taskName?: string | null;
	taskDescription?: string | null;
	projectId?: number | null;
	tagIds?: string | null;
	assignerId?: number | null;
	respondId?: number | null;
	requesterId?: number | null;
	createDate?: Date | null;
	updateDate?: Date | null;
	createBy?: number | null;
	updateBy?: number | null;
	enabled?: boolean | null;
	nextDateCreateTask1?: Date | null;
	nextDateCreateTask2?: Date | null;
	nextDateCreateTask3?: Date | null;
	nextDateCreateTask4?: Date | null;
	nextDateCreateTask5?: Date | null;
	respondName?: string | null;
	taskCreated?: number | null;
	upcomingDay?: number | null;
	upcomingDayCal?: number | null;
	lastActiveTask?: string | null;
	lastTaskName?: string | null;
	lastTaskStatus?: number | null;
	lastTaskPlanFinishedDate?: Date | null;
	lastTaskFinishedDate?: Date | null;
	lastTaskOverdueDay?: number | null;
	isSomePersonInActive?: boolean | null;
}

export function TaskRecurance2DataDef(): TaskRecurance2Data {
	const x: TaskRecurance2Data = {
		recuranceMode: RecuranceModes.None,
		createTaskBeforeUnit: "D",
		dailyOnTime: "00:00",
		freqDay: 1, freqMonth: 1, freqWeek: 1, freqYear: 1
	};
	return x;
}


export type TaskFormFieldData = {
	taskName?: string | null,
	taskDescription?: string | null,
	projectId?: number | null,
	assignerId?: number | null,
	assignerName?: string | null,
	respondId?: number | null,
	respondName?: string | null,
	requestBy?: number | null,
	requesterName?: string | null,
	planFinishedDate?: Date | null,
	createSubTaskFromTaskId?: string | null,
	enabled?: boolean | null,

	// recurance1?: TaskRecuranceData | null,
	// recurance2?: TaskRecuranceData | null,
	// recurance3?: TaskRecuranceData | null,
	recurance?: TaskRecurance2Data | null,
	tagIds?: number[] | null,
	finishedByNum?: number | null,
	finishedByUnit?: "D" | "W" | "M" | "M0" | "M1" | null,
};

export interface tb_User {
	userId?: number | null;
	userType?: number | null;
	isAdmin?: boolean | null;
	registerId?: number | null;
	authLineId?: string | null;
	authMobileNo?: string | null;
	firstName?: string | null;
	lastName?: string | null;
	fullName?: string | null;
	nickName?: string | null;
	companyName?: string | null;
	pictureUrl?: string | null;
	inActiveDate?: Date | null;
	inActiveReason?: string | null;
	isReceiptance?: boolean | null;
	about?: string | null;
	email?: string | null;
	location?: string | null;
	status?: number | null;
	createDate?: Date | null;
	updateDate?: Date | null;
	createBy?: string | null;
	updateBy?: string | null;
	lastLogonDate?: Date | null;
	lastConnectDate?: Date | null;
	groupInviteCode?: string | null;
	groupInviteOn?: boolean | null;
	activeGroupId?: number | null;
	positionName?: string | null;
	coverImageUrl?: string | null;
	profileImage?: string | null;
	userRole?: number | null;
	isSell?: boolean | null;
	groupInviteExpired?: Date | null;
	provinceId?: number | null;
	amphurId?: number | null;
	districtId?: number | null;
	departmentName?: string | null;
	extUserId?: number | null;
	saleId?: number | null;
	csId?: number | null;
	extSaleId?: number | null;
	extCsId?: number | null;
	uniqueId?: string | null;
	lastMsgIdReceive?: string | null;
	abbrName?: string | null;
	bgColor?: string | null;
	foreColor?: string | null;
	dummyRowNo?: number | null;
	extUserSystem?: string | null;
	companyId?: number | null;
	isDev?: boolean | null;
	displayName?: string | null;
	chatAlignRight?: string | null;
	displayName2?: string | null;
	isActive?: boolean | null;
	headId1?: number | null;
	headId2?: number | null;
	headId3?: number | null;
	employeeId?: number | null;
	empKey?: number | null;
	divisionName?: string | null;
}

export enum HookMethods {
	POST = "POST"
}

export enum HookAuths {
	None = "None",
	BearerToken = "BearerToken"
}

export enum HookEvents {
	ChangeTaskStatus = "ChangeTaskStatus",
	ChangeTaskStatusByHuman = "ChangeTaskStatusByHuman"
}

export enum HookBodyTypes {
	None = "None",
	FormData = "FormData",
	Json = "Json"
}

export enum HookDataSection {
	Header = "Header",
	FormData = "FormData",
	Json = "Json"
}

export interface tb_HookData {
	hookId?: number | null;
	dataSection?: HookDataSection | null;
	seq?: number | null;
	name?: string | null;
	value?: string | null;
}

export interface tb_Hook {
	hookId?: number | null;
	method?: HookMethods | null;
	hookUrl?: string | null;
	authMethod?: HookAuths | null;
	bearerToken?: string | null;
	purpose?: string | null;
	event?: HookEvents | null;
	bodyType?: HookBodyTypes | null;
	createBy?: number | null;
	createDate?: Date | null;
	updateBy?: number | null;
	updateDate?: Date | null;
	enabled?: boolean | null;
} 

export interface sp_HookSearch  { 
	hookId?: number | null;
	method?: string | null;
	hookUrl?: string | null;
	authMethod?: string | null;
	bearerToken?: string | null;
	purpose?: string | null;
	event?: string | null;
	bodyType?: string | null;
	createBy?: number | null;
	createDate?: Date | null;
	updateBy?: number | null;
	updateDate?: Date | null;
	enabled?: boolean | null;
	hookCountOk?: number | null;
	hookCountError?: number | null;
	createByUser?: string | null;
	updateByUser?: string | null;
} 

export interface sp_LoadUserConfig { 
	chatAlignRight: string | null;
	pushFromChat: boolean | null;
	pushFromWp: boolean | null;
	allowHookManager: boolean | null;
	isTaskRecuranceAdmin: boolean | null;
} 
